import { render, staticRenderFns } from "./SendCardSection.vue?vue&type=template&id=61796bda&"
import script from "./SendCardSection.vue?vue&type=script&lang=js&"
export * from "./SendCardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports